export const BREAKPOINTS = {
  xs: '320px',
  sm: '576px',
  md: '768px',
  lg: '1024px',
  xl: '1200px'
};

export const TRANSITIONS = {
  default: '0.3s ease-in-out',
  slow: '0.5s ease-in-out',
  fast: '0.2s ease-in-out'
};

export const darkTheme = {
  // Base colors
  bg: "#1C1C27",
  bgLight: "#1C1E27",
  bgDark: "#15151E",
  primary: "#854CE6",
  secondary: "#6D44B8",
  accent: "#FF5757",

  // Text colors
  text_primary: "#F2F3F4",
  text_secondary: "#b1b2b3",
  text_tertiary: "#888999",

  // Card colors
  card: "#171721",
  card_light: "#191924",
  card_hover: "#1E1E2A",

  // Button colors
  button: "#854CE6",
  button_hover: "#7039DD",
  button_active: "#6D44B8",

  // Status colors
  success: "#4CAF50",
  warning: "#FFA726",
  error: "#EF5350",
  info: "#29B6F6",

  // Basic colors
  white: "#FFFFFF",
  black: "#000000",

  // Gradients
  gradient: "linear-gradient(225deg, #854CE6 0%, #6D44B8 100%)",
  gradient_alt: "linear-gradient(135deg, #854CE6 0%, #FF5757 100%)",

  // Shadows
  shadow_sm: "0 2px 8px rgba(0, 0, 0, 0.15)",
  shadow_md: "0 4px 16px rgba(0, 0, 0, 0.15)",
  shadow_lg: "0 8px 32px rgba(0, 0, 0, 0.15)",

  // Border radius
  borderRadius_sm: "4px",
  borderRadius_md: "8px",
  borderRadius_lg: "16px",

  // Spacing
  spacing_xs: "4px",
  spacing_sm: "8px",
  spacing_md: "16px",
  spacing_lg: "24px",
  spacing_xl: "32px",

  // Z-index levels
  z_tooltip: 10,
  z_modal: 20,
  z_popover: 30,
  z_header: 40,
  z_overlay: 50
};

export const lightTheme = {
  // Base colors
  bg: "#FFFFFF",
  bgLight: "#F9F9F9",
  bgDark: "#F0F0F0",
  primary: "#854CE6",
  secondary: "#6D44B8",
  accent: "#FF5757",

  // Text colors
  text_primary: "#2C2C35",
  text_secondary: "#4E4E5C",
  text_tertiary: "#6E6E7C",

  // Card colors
  card: "#FFFFFF",
  card_light: "#F9F9F9",
  card_hover: "#F5F5F5",

  // Button colors
  button: "#854CE6",
  button_hover: "#7039DD",
  button_active: "#6D44B8",

  // Status colors
  success: "#4CAF50",
  warning: "#FFA726",
  error: "#EF5350",
  info: "#29B6F6",

  // Basic colors
  white: "#FFFFFF",
  black: "#000000",

  // Gradients
  gradient: "linear-gradient(225deg, #854CE6 0%, #6D44B8 100%)",
  gradient_alt: "linear-gradient(135deg, #854CE6 0%, #FF5757 100%)",

  // Shadows
  shadow_sm: "0 2px 8px rgba(0, 0, 0, 0.05)",
  shadow_md: "0 4px 16px rgba(0, 0, 0, 0.08)",
  shadow_lg: "0 8px 32px rgba(0, 0, 0, 0.1)",

  // Border radius
  borderRadius_sm: "4px",
  borderRadius_md: "8px",
  borderRadius_lg: "16px",

  // Spacing
  spacing_xs: "4px",
  spacing_sm: "8px",
  spacing_md: "16px",
  spacing_lg: "24px",
  spacing_xl: "32px",

  // Z-index levels
  z_tooltip: 10,
  z_modal: 20,
  z_popover: 30,
  z_header: 40,
  z_overlay: 50
};
